import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

class ProfileDropdown extends Component {
  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  /*:: toggleDropdown: () => void */


  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    const profilePic = this.props.profilePic || null;
    return /*#__PURE__*/React.createElement(Dropdown, {
      isOpen: this.state.dropdownOpen,
      toggle: this.toggleDropdown
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      "data-toggle": "dropdown",
      tag: "button",
      className: "nav-link dropdown-toggle nav-user arrow-none mr-0",
      onClick: this.toggleDropdown,
      "aria-expanded": this.state.dropdownOpen
    }, /*#__PURE__*/React.createElement("span", {
      className: "account-user-avatar"
    }, /*#__PURE__*/React.createElement("img", {
      src: profilePic,
      className: "rounded-circle",
      alt: "user"
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "account-user-name"
    }, this.props.username), /*#__PURE__*/React.createElement("span", {
      className: "account-position"
    }, this.props.userTitle))), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true,
      className: "dropdown-menu-animated topbar-dropdown-menu profile-dropdown"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.toggleDropdown
    }, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-header noti-title"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "text-overflow m-0"
    }, "Welcome !!")), this.props.menuItems.map((item, i) => {
      return /*#__PURE__*/React.createElement(Link, {
        to: item.redirectTo,
        className: "dropdown-item notify-item",
        key: i + '-profile-menu'
      }, /*#__PURE__*/React.createElement("i", {
        className: `${item.icon} mr-1`
      }), /*#__PURE__*/React.createElement("span", null, item.label));
    }))));
  }

}

export default ProfileDropdown;